/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { SkipLinkComponent } from './skip-link';
export * from './skip-link-constants';
export * from './skip-link';
export function defineSkipLinkComponent() {
    defineCustomElement(SkipLinkComponent);
}
